// @ts-nocheck
import * as d3 from 'd3'
import * as codes from '../../utils/codes.js'
import utils from '../../utils/utils.js'
import ChartCard from '../../components/ChartCard/ChartCard'
import DagreDirectedChart from '../../components/DagreDirectedChart/DagreDirectedChart'
// import dbsLogoSvgBase64 from '../../assets/base64/dbsLogoSvgBase64.js'
import * as DagreDirectedTypes from '../../types/charts/dagreDirected'
import * as DagreDirectedChartTypes from '../../types/components/dagreDirectedChart'
// import * as screenShot from '../../utils/screenShot.js'

export default class CompanyStockRelationship implements DagreDirectedTypes.ICompanyStockRelationship {
  private dom: HTMLElement
  private el: d3.Selection<d3.BaseType, any, any, any>
  private chartCard: ChartCard
  private chartSelector: d3.Selection<d3.BaseType, any, any, any>
  private dagreDirectedChart: DagreDirectedChart
  // 切換截圖模式前的尺寸
  private cardOriginSize: { width: string; height: string } = { width: '', height: '' }
  // 卡片樣式
  private cardStyle: any

  constructor (dom, options) {
    if (!dom || !options) {
      throw new Error('missing necessary parameter');
    }
    this.dom = dom
    
    // -- 放置卡片 --
    this.el = d3.select(dom)
    this.cardStyle = options.size == null ? utils.clone(codes.COMPANY_STOCK_RELATIONSHIP_CARD_SIZE[codes.DEFAULT_CARD_SIZE_TYPE]) : codes.COMPANY_STOCK_RELATIONSHIP_CARD_SIZE[options.size]
    this.chartCard = new ChartCard(
      this.el,
      // {
      //   name: 'company-stock-relationship',
      //   title: options.title,
      //   subtitle: '股權百分比為持有股份/(實收資本額/10)*100%',
      //   watermarkBase64: '',
      //   logoBase64: dbsLogoSvgBase64,
      //   tooltip: `股權結構關係圖為一張展開式的樹狀結構圖表<br>
      //             ，以所查詢之公司做為中心進行運算，方向向<br>
      //             上為公司的【法人】董監事、股東(如有資訊)<br>
      //             ，方向向下為公司的投資對象(即公司擔任其<br>
      //               他單位的法人董事)`,
      //   size: options.size || codes.DEFAULT_CARD_SIZE_TYPE,
      //   style: this.cardStyle
      // }
      options
    )
    this.chartSelector = this.chartCard.chartSelector()
    this.cardOriginSize = {
      width: this.el.style('width'),
      height: this.el.style('height')
    }

    // -- 放入圖表 --
    this.dagreDirectedChart = new DagreDirectedChart(this.chartSelector, {})

  }

  private doInit ({ nodes = [], edges = [], expandAll, direction }: {
    nodes: Array<DagreDirectedChartTypes.ChartNode>;
    edges: Array<DagreDirectedChartTypes.ChartEdge>;
    expandAll: boolean;
    direction: string;
  }): void {
    // 重新render
    this.dagreDirectedChart.init({ nodes, edges, expandAll, direction })
  }

  public init (dataSet: {
    nodes: Array<DagreDirectedChartTypes.ChartNode>;
    edges: Array<DagreDirectedChartTypes.ChartEdge>;
    expandAll: boolean;
    direction: string;
  }): void {
    // 將資料記住
    // this.dataSet = dataSet
    // 觸發顯示圖表動畫
    utils.addScrollTrigger(this.dom, () => this.doInit(dataSet))
  }

  public resetNodes ({ nodes = [], edges = [] }: {
    nodes: Array<DagreDirectedChartTypes.ChartNode>,
    edges: Array<DagreDirectedChartTypes.ChartEdge>,
    // center?: boolean // 置中
  }): void {
    // 重新render
    this.dagreDirectedChart.resetNodes({ nodes, edges })
  }

  public setTitle (title): void {
    this.chartCard.setTitle(title)
  }

  public changeDirection (direction: string): void {
    this.dagreDirectedChart.changeDirection(direction)
  }

  public setStyle (returnStyle) {
    this.dagreDirectedChart.setStyle(returnStyle)
  }

  public onNodeClick (callback): void {
    // this.nodeClickCallback = callback
    this.dagreDirectedChart.onNodeClick((d) => {
      // // 禁止點擊：非公司、或為根節點、或無可展開的父節點
      // if (!d.uniID || d.id === this.rootID || d.hasTop === false) {
      //   return
      // }
      callback(d)
    })
  }

  public onExtandBtnClick (callback): void {
    this.dagreDirectedChart.onExtandBtnClick((d) => {
      callback(d)
    })
  }

  public toggleTopNodes (id: string): void {
    this.dagreDirectedChart.toggleTopNodes(id)
  }

  public resize () {
    // 置中
    this.dagreDirectedChart.resize()
  }

  public async screenShotMode (isScreenShot: boolean): void {
    if (isScreenShot) {
      // 截圖的神奇bug修正
      // 說明：將marker-end屬性內的網址刪除
      // 比如，原本是marker-end="url(http://localhost:8100/companydetail?uniid=73251209#arrowhead290)"
      // 修正為marker-end="url(#arrowhead290)"
      try {
        this.el.selectAll('.edgePath').select('path').attr('marker-end', (d,i,all) => {
          const self = d3.select(all[i])
          const attr = self.attr('marker-end')
          if (attr) {
            const arr = attr.split('#')
            return arr[1] ? `url(#${arr[1]}` : ''
          }
          return ''
        })
      } catch (e) { console.error(e) }
      // 取得寬高
      const screenShotSize = this.dagreDirectedChart.getChartSize()
      // 將卡片寬高設為和符合圖表尺寸（圖表寬高加上卡片間距）
      let width = screenShotSize.width + this.cardStyle['padding-left'] + this.cardStyle['padding-right']
      let height = screenShotSize.height + this.cardStyle['padding-top'] + this.cardStyle['padding-bottom'] + this.cardStyle.header.height + this.cardStyle.footer.height + 20
      width = width * 1.1
      height = height * 1.1
      if (width < 640) {
        width = 640
      }
      if (height < 480) {
        height = 480
      }
      this.chartCard.setCardSize({
        width: `${width}px`,
        height: `${height}px`
      })
      // 置中
      this.dagreDirectedChart.resize()
    } else {
      // 將卡片寬高還原
      this.chartCard.setCardSize({
        width: this.cardOriginSize.width,
        height: this.cardOriginSize.height
      })
      // 置中
      this.dagreDirectedChart.resize()
    }

    // 截圖
    // await screenShot.downloadScreenImage(this.dom)

  }

}